<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
        <template slot-scope="scope" slot="contentForm">
            <avue-ueditor v-model="scope.row.content" :upload="upload"></avue-ueditor>
        </template>
    </avue-crud>
</template>

<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText:'新增主题活动', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '标题',
              overHidden: true,
              prop: 'title',
              span: 24,
              rules: [{
                type: 'string', required: true, message: '输入不正确', trigger: 'blur'
              }],
              headerAlign: 'left',
              align: 'left',
            },
            {
              label: '封面图',
              prop: 'filepaths',
              // dataType: 'string', // 单图不要此属性
              type: 'upload',
              listType: 'picture-img', // 单图
              // listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24,
              rules: [{
                required: true, message: '图片不能为空', trigger: 'blur'
              }]
            },
            {
              label: '视频',
              prop: 'video',
              type: 'upload',
              listType: 'picture-img',
              span: 24,
              hide: true,
              oss: 'ali', // 阿里云oss配置
            },
            {
              label: '内容',
              prop: 'content',
              formslot: true,
              span: 24,
              hide: true, // 隐藏列
            }
          ]
        }
      }
    }
  }
</script>
